 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-accounting-accounting-module":"pages-accounting-accounting-module","pages-accpostingsetup-accpostingsetup-module":"pages-accpostingsetup-accpostingsetup-module","pages-batch-number-enquiry-batch-number-enquiry-module":"pages-batch-number-enquiry-batch-number-enquiry-module","pages-chartaccmonthendposting-chartaccmonthendposting-module":"pages-chartaccmonthendposting-chartaccmonthendposting-module","pages-dishes-dishes-module":"pages-dishes-dishes-module","pages-employee-leave-employee-leave-module":"pages-employee-leave-employee-leave-module","pages-importExportMaster-importExportMaster-module":"pages-importExportMaster-importExportMaster-module","pages-login-management-login-management-module":"pages-login-management-login-management-module","pages-login-user-login-user-module":"pages-login-user-login-user-module","pages-main-main-module":"pages-main-main-module","pages-material-cat-material-cat-module":"pages-material-cat-material-cat-module","pages-material-material-module":"pages-material-material-module","pages-medicine-type-medicine-type-module":"pages-medicine-type-medicine-type-module","pages-outbound-outbound-module":"pages-outbound-outbound-module","pages-report-control-report-control-module":"pages-report-control-report-control-module","pages-role-permission-role-permission-module":"pages-role-permission-role-permission-module","pages-tchangeacct-tchangeacct-module":"pages-tchangeacct-tchangeacct-module","pages-temployee-temployee-module":"pages-temployee-temployee-module","pages-titem-cate-titem-cate-module":"pages-titem-cate-titem-cate-module","pages-titem-titem-module":"pages-titem-titem-module","pages-tmedicine-tmedicine-module":"pages-tmedicine-tmedicine-module","pages-tpackage-tpackage-module":"pages-tpackage-tpackage-module","pages-tpayment-tpayment-module":"pages-tpayment-tpayment-module","pages-tpricebook-tpricebook-module":"pages-tpricebook-tpricebook-module","pages-twhse-twhse-module":"pages-twhse-twhse-module","report-report-module":"report-report-module","default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b":"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b","pages-billpay-billpay-module":"pages-billpay-billpay-module","pages-billpay-walkin-billpay-walkin-module":"pages-billpay-walkin-billpay-walkin-module","pages-change-pay-change-pay-module":"pages-change-pay-change-pay-module","pages-dishes-plan-dishes-plan-module":"pages-dishes-plan-dishes-plan-module","pages-historyByDate-historyByDate-module":"pages-historyByDate-historyByDate-module","pages-inbound-inbound-module":"pages-inbound-inbound-module","pages-journal-journal-module":"pages-journal-journal-module","pages-material-list-material-list-module":"pages-material-list-material-list-module","pages-physio-physio-module":"pages-physio-physio-module","pages-prescriptionPickList-prescriptionPickList-module":"pages-prescriptionPickList-prescriptionPickList-module","pages-prescriptionlist-prescriptionlist-module":"pages-prescriptionlist-prescriptionlist-module","pages-void-voucher-void-voucher-module":"pages-void-voucher-void-voucher-module","pages-waiting-consult-waiting-consult-module":"pages-waiting-consult-waiting-consult-module","pages-xray-xray-module":"pages-xray-xray-module","default~pages-copy-prescription-copy-prescription-module~pages-tprescription-tprescription-module":"default~pages-copy-prescription-copy-prescription-module~pages-tprescription-tprescription-module","pages-copy-prescription-copy-prescription-module":"pages-copy-prescription-copy-prescription-module","pages-tprescription-tprescription-module":"pages-tprescription-tprescription-module","default~pages-on-consult-on-consult-module~pages-tpatient-tpatient-module":"default~pages-on-consult-on-consult-module~pages-tpatient-tpatient-module","pages-on-consult-on-consult-module":"pages-on-consult-on-consult-module","pages-tpatient-tpatient-module":"pages-tpatient-tpatient-module","default~pages-tgrn-tgrn-module~pages-tpurchase-order-tpurchase-order-module":"default~pages-tgrn-tgrn-module~pages-tpurchase-order-tpurchase-order-module","pages-tpurchase-order-tpurchase-order-module":"pages-tpurchase-order-tpurchase-order-module","default~pages-booking-arrive-booking-arrive-module~pages-booking-booking-module":"default~pages-booking-arrive-booking-arrive-module~pages-booking-booking-module","pages-booking-arrive-booking-arrive-module":"pages-booking-arrive-booking-arrive-module","pages-booking-booking-module":"pages-booking-booking-module","pages-tgrn-tgrn-module":"pages-tgrn-tgrn-module","pages-debug-debug-module":"pages-debug-debug-module","pages-home-home-module":"pages-home-home-module","pages-outstanding-outstanding-module":"pages-outstanding-outstanding-module","pages-patient-history-patient-history-module":"pages-patient-history-patient-history-module","pages-questionnaire-questionnaire-module":"pages-questionnaire-questionnaire-module","pages-tbed-tbed-module":"pages-tbed-tbed-module","pages-tbookaux-tbookaux-module":"pages-tbookaux-tbookaux-module","pages-tpatient-type-tpatient-type-module":"pages-tpatient-type-tpatient-type-module","pages-tshop-bldg-tshop-bldg-module":"pages-tshop-bldg-tshop-bldg-module","pages-tshop-tshop-module":"pages-tshop-tshop-module","pages-tvendor-tvendor-module":"pages-tvendor-tvendor-module","print-print-module":"print-print-module"}[chunkId]||chunkId) + "." + {"common":"b236c04311b5a95b9321","pages-accounting-accounting-module":"cb09beabab8931409f31","pages-accpostingsetup-accpostingsetup-module":"9f8146aa6960a92f6e32","pages-batch-number-enquiry-batch-number-enquiry-module":"080e4223f5ab8193f599","pages-chartaccmonthendposting-chartaccmonthendposting-module":"796f07e9f56514347226","pages-dishes-dishes-module":"d421b6c61a25aa084525","pages-employee-leave-employee-leave-module":"bc09345f8a0ac7b761fb","pages-importExportMaster-importExportMaster-module":"0cce5d01ace1916bf7fb","pages-login-management-login-management-module":"aff574b1cddbc0910373","pages-login-user-login-user-module":"75d298234e9b8a877b43","pages-main-main-module":"b85d46103b1233aad8c2","pages-material-cat-material-cat-module":"ad1f26280c2c97b0261e","pages-material-material-module":"ee1f1a883a203d9ea57c","pages-medicine-type-medicine-type-module":"cd10639f71c076783bd8","pages-outbound-outbound-module":"bb8392baed3d2dcc0c31","pages-report-control-report-control-module":"13464917f56d4b90d472","pages-role-permission-role-permission-module":"0c1b7e46145f02b41c9b","pages-tchangeacct-tchangeacct-module":"2669ecc6e2dd24c20926","pages-temployee-temployee-module":"8b022ed597831b1508c3","pages-titem-cate-titem-cate-module":"6a213462f85f80c58f86","pages-titem-titem-module":"bf7ba3a67de5ef3d5870","pages-tmedicine-tmedicine-module":"efa66833ddf7b61a55ce","pages-tpackage-tpackage-module":"88c633cce511599cc810","pages-tpayment-tpayment-module":"73b3e33a9f172ae167b6","pages-tpricebook-tpricebook-module":"90c420d901d31b3f418f","pages-twhse-twhse-module":"6389f68a6d2ae9e3aad0","report-report-module":"feaf98d12ad039099c94","default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b":"1629d9c3bf364a7697ad","pages-billpay-billpay-module":"5e72d05515cd568637b8","pages-billpay-walkin-billpay-walkin-module":"65a2028fe3e2d97d858f","pages-change-pay-change-pay-module":"1657253a1a209730d854","pages-dishes-plan-dishes-plan-module":"bfa0f6fa92eb46472883","pages-historyByDate-historyByDate-module":"c4fa8f800449884e25b5","pages-inbound-inbound-module":"ad470a6f4e4967c11f9a","pages-journal-journal-module":"a87aae3784e398b15908","pages-material-list-material-list-module":"c7352420b2c1d3c41706","pages-physio-physio-module":"4aeb5d568f76ec1613bc","pages-prescriptionPickList-prescriptionPickList-module":"904b89adb04a33879565","pages-prescriptionlist-prescriptionlist-module":"772fae13309f8a4f13e8","pages-void-voucher-void-voucher-module":"0543ffe15f2f5fa1d5e8","pages-waiting-consult-waiting-consult-module":"45b0beafcbf44c95076a","pages-xray-xray-module":"ea1c525267146e5c7f85","default~pages-copy-prescription-copy-prescription-module~pages-tprescription-tprescription-module":"f40874932d79e8c7dbeb","pages-copy-prescription-copy-prescription-module":"100df679bd34552756d2","pages-tprescription-tprescription-module":"99ab449fd77ee1d71aa0","default~pages-on-consult-on-consult-module~pages-tpatient-tpatient-module":"1b0776b17d45e75d7796","pages-on-consult-on-consult-module":"08fa54c345fcb49f87bd","pages-tpatient-tpatient-module":"a7c8027c62515ba091c8","default~pages-tgrn-tgrn-module~pages-tpurchase-order-tpurchase-order-module":"cb626d6fa1af83997456","pages-tpurchase-order-tpurchase-order-module":"9ee857f2af62ebea5c83","default~pages-booking-arrive-booking-arrive-module~pages-booking-booking-module":"a64134768fbd1acb400a","pages-booking-arrive-booking-arrive-module":"5c1fe0d123c9eb158acb","pages-booking-booking-module":"244ffb741e10caf3da90","pages-tgrn-tgrn-module":"5fe674860f8cd0b74308","pages-debug-debug-module":"92c6fd29d9638d55d758","pages-home-home-module":"f040ceee561bccf30a91","pages-outstanding-outstanding-module":"68891449da0fc8eff273","pages-patient-history-patient-history-module":"2e4cf0b029ab5b406c48","pages-questionnaire-questionnaire-module":"0bbb81bc8000ca7f5141","pages-tbed-tbed-module":"94399163eb2dfe04da80","pages-tbookaux-tbookaux-module":"a6973339f486c19fa13f","pages-tpatient-type-tpatient-type-module":"ce7fa5fe99293cdf4b7d","pages-tshop-bldg-tshop-bldg-module":"7d48c79e15b3c6da4b05","pages-tshop-tshop-module":"a74f4902f67db075026a","pages-tvendor-tvendor-module":"1a77d20a44928b91a277","print-print-module":"f56991bd7278ec1dc94a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
